import { NativeMarket } from '@capacitor-community/native-market'
import { Capacitor } from '@capacitor/core'
import { IonIcon } from '@ionic/react'
import { gridOutline } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/actions/Button'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

const appId = Capacitor.getPlatform() === 'android' ? 'com.vihreaalyenergia.app' : 'id1545659340'

const InsufficientVersion: React.FC = () => {
	const { t } = useTranslation('pages_insufficientVersion')

	const openStorePage = () =>
		NativeMarket.openStoreListing({
			appId,
		})

	return (
		<PublicWrapper>
			<div className='alert flex justify-center items-center text-center flex-col gap-4'>
				<IonIcon
					className='text-brand-primary-100-dark'
					icon={gridOutline}
					style={{ fontSize: '4.3em', margin: 'auto' }}
				/>
				<h2 className='text-white'>{t('versioVanhentunut')}</h2>
				{t('paivita')}
				<Button className='button' onClick={openStorePage}>
					{t('ok')}
				</Button>
			</div>
		</PublicWrapper>
	)
}
export default InsufficientVersion
